module.exports = __webpack_public_path__ + "img/1.84bb215a.png";